"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import useSiteInfo from "@workspace/nextjs_utils/src/siteInfo/useSiteInfo";
import formatBetRange from "../formatBetRange";
import formatVolatility from "../formatVolatility";

type GameStat = { label: string; value: string };

const useGameStats = (game: SingleGameFragment): GameStat[] => {
  const { walletCurrency, isLoyaltyHidden, t } = useGamePageData();
  const { site } = useSiteInfo();

  const { minBet, maxBet, rtp, payLines, hitRatio, volatility, inLoyalty } =
    game;
  const stats: GameStat[] = [];

  // Empire does not publish RTP.
  if (rtp && site !== "empire") {
    stats.push({ label: t("game.stats.rtp", "RTP"), value: `${rtp}%` });
  }

  const betRange = formatBetRange(minBet, maxBet, walletCurrency, t);
  if (betRange) stats.push(betRange);

  const volatilityLabel = formatVolatility(volatility, t);
  if (volatilityLabel) {
    stats.push({
      label: t("game.stats.volatility", "Volatility"),
      value: volatilityLabel,
    });
  }

  if (payLines) {
    stats.push({
      label: t("game.stats.paylines", "Paylines"),
      value: payLines,
    });
  }
  if (hitRatio) {
    stats.push({
      label: t("game.stats.hitratio", "Hit Ratio"),
      value: `${hitRatio}%`,
    });
  }

  // Same tags that drop loyalty from the header's profile menu.
  if (!isLoyaltyHidden) {
    stats.push({
      label: t("game.stats.loyaltysystem", "Loyalty system"),
      value: inLoyalty
        ? t("game.stats.included", "Included")
        : t("game.stats.notincluded", "Not included"),
    });
  }

  return stats;
};

export default useGameStats;
